module.exports = __webpack_public_path__ + "img/app_bg.0a82e79.png";